import { AlertsState } from '@src/types/Alerts';
import mqtt, { MqttState } from '@store/reducers/mqttData';
import { CombinedState, combineReducers } from 'redux';
import alerts from './alerts';
import config, { ConfigState } from './configData';
import controlsLock, { ControlsLockState } from './controlsLock';
import service, { ServiceState } from './serviceData';
import site, { SiteState } from './siteReducer';
import user, { UserState } from './userData';

export interface AppDefaultStateProps {
  service: ServiceState;
  user: UserState;
  site: SiteState;
  mqtt: MqttState;
  config: ConfigState;
  alerts: AlertsState;
  controlsLock: ControlsLockState;
}

export type AggregatedState =
  | ServiceState
  | UserState
  | SiteState
  | MqttState
  | ConfigState
  | AlertsState
  | ControlsLockState;

export type UnionOfKeys<T> = T extends T ? keyof T : never;

export type StoreConnectorData = {
  service?: 'all' | UnionOfKeys<ServiceState>[];
  user?: 'all' | UnionOfKeys<UserState>[];
  site?: 'all' | UnionOfKeys<SiteState>[];
  mqtt?: 'all' | UnionOfKeys<MqttState>[];
  config?: 'all' | UnionOfKeys<ConfigState>[];
  alerts?: 'all' | UnionOfKeys<AlertsState>[];
  controlsLock?: 'all' | UnionOfKeys<ControlsLockState>[];
};

export type AppDefaultState = CombinedState<AppDefaultStateProps>;

export default combineReducers({
  service,
  user,
  site,
  mqtt,
  config,
  alerts,
  controlsLock,
});
